export default {
  getEnergyData: (state) => state.energyData,
  getDistrictHeatingPotentialsData: (state) =>
    state.districtHeatingPotentialsData,
  getCommunityData: (state) => state.communityData,
  getPotentialData: (state) => state.potentialData,
  getDashboard3GroupBy: (state) => state.dashboard3groupBy,
  getLastScrollPosition: (state) => state.lastScrollPosition,
};
